import { api } from './api-client';
import type {
  ListPlatformDevelopersResponse,
  PlatformDeveloper,
  CreateDeveloperRequest,
  CreateDeveloperResponse,
  CreateClusterRequest,
  CreateClusterResponse,
  UpdateClusterRequest,
} from '@livinhome/shared';

export type { PlatformDeveloper };

export async function listDevelopers(): Promise<PlatformDeveloper[]> {
  const { data } = await api.get<ListPlatformDevelopersResponse>('/platform/developers');
  return data.developers;
}
export async function createDeveloper(body: CreateDeveloperRequest): Promise<CreateDeveloperResponse> {
  const { data } = await api.post<CreateDeveloperResponse>('/platform/developers', body);
  return data;
}
export async function createCluster(body: CreateClusterRequest): Promise<CreateClusterResponse> {
  const { data } = await api.post<CreateClusterResponse>('/platform/clusters', body);
  return data;
}
export async function archiveDeveloper(id: string): Promise<void> {
  await api.post(`/platform/developers/${id}/archive`);
}
export async function restoreDeveloper(id: string): Promise<void> {
  await api.post(`/platform/developers/${id}/restore`);
}
export async function updateCluster(id: string, body: UpdateClusterRequest): Promise<void> {
  await api.patch(`/platform/clusters/${id}`, body);
}
export async function archiveCluster(id: string): Promise<void> {
  await api.post(`/platform/clusters/${id}/archive`);
}
export async function restoreCluster(id: string): Promise<void> {
  await api.post(`/platform/clusters/${id}/restore`);
}
